<div class="bkrn">
  <div class="search-bar">
    <label>
      <input name="term" [(ngModel)]="term" placeholder="{{ 'SEARCH_YOUR_SAVED_ITEMS' | translate }}" />
      <i class="fa fa-search"></i>
    </label>
    <span *ngIf="bookmarks.length" (click)="open(bookmarkModal)" title="Delete all bookmarks"
      ><i class="fa fa-trash"></i
    ></span>
  </div>

  <div class="bookmark-list">
    <ul *ngIf="bookmarks.length" cdkDropList (cdkDropListDropped)="drop($event)">
      <ng-container *ngFor="let bookmark of bookmarks | searchfilter: 'title':term">
        <li
          cdkDrag
          class="bk-article"
          *ngIf="
            bookmark.context.contextType === 'relax' ||
            bookmark.context.contextType === 'radar' ||
            bookmark.context.contextType === 'reader' ||
            bookmark.context.contextType === 'agenda'
          "
        >
          <div class="bk-card-container">
            <div class="bk-card-header">
              <div class="bk-card-image" *ngIf="bookmark.context.image">
                <a href (click)="openBookmark(bookmark, $event)">
                  <img alt="{{ bookmark.title }}" src="{{ bookmark.context.image }}" />
                </a>
              </div>
            </div>

            <div class="bk-card-body">
              <span class="published-date">{{ bookmark.context.publication_date | date: 'medium' }}</span>
              <div class="bk-card-title">
                <h2>
                  <a href (click)="openBookmark(bookmark, $event)">{{ bookmark.title }}</a>
                </h2>
              </div>
            </div>

            <div class="bk-card-footer">
              <ul class="bk-card-footer-action">
                <li class="favicon" *ngIf="bookmark.context.contextType === 'agenda'">
                  <span>&nbsp;&nbsp;{{ bookmark.last_update_date | date }}</span>
                </li>

                <li class="favicon" title="{{ bookmark.context.publisher }}" *ngIf="bookmark.context.publisher">
                  <a href="{{ bookmark.context.source }}" target="_blank">
                    <img
                      alt="{{ bookmark.context.publisher }}"
                      src="https://www.google.com/s2/favicons?domain={{ bookmark.context.publisher }}"
                    />
                    <span>&nbsp;|&nbsp;{{ bookmark.context.publisher }}</span>
                  </a>
                </li>
                <li class="bk-publish">
                  <div class="publish-btn">
                    <div class="dropdown-menu-wrapper">
                      <div title="Send to publish">
                        <i class="icon rn_publish"></i>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="bookmarked" title="Delete">
                  <a href (click)="removeBookmark($event, bookmark.id)"><i class="fa fa-trash"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </li>

        <li cdkDrag class="bk-search" *ngIf="bookmark.context.contentType === 'search'">
          <div class="bk-card-container">
            <div class="bk-card-body" (click)="searchTerm(bookmark)">
              <h2>
                <a>« {{ bookmark.title }} »</a>
              </h2>
              <span class="title-icon">
                <i class="fa fa-search"></i>
              </span>
            </div>

            <div class="bk-card-footer">
              <ul class="bk-card-footer-action">
                <li class="bookmarked" title="Delete">
                  <a href (click)="removeBookmark($event, bookmark.id)"><i class="fa fa-trash"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ng-container>
    </ul>

    <div *ngIf="!bookmarks.length" class="no-bookmark">
      <p>{{ 'NO_SAVED_ITEMS' | translate }}</p>
      <a href>
        <i class="fa fa-long-arrow-left"></i>
        {{ 'GO_TO_DASHBOARD' | translate }}
      </a>
    </div>
    <app-loading *ngIf="isLoading" [inline]="false"></app-loading>
  </div>
</div>

<ng-template #bookmarkModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="bookmarks-grid-modal">
      {{ 'BOOKMARK_MODAL_TITLE' | translate }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ 'BOOKMARK_MODAL_BODY' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="save-button" (click)="removeAllBookmark()">Delete</button>
  </div>
</ng-template>
